import { adminInstance } from '../axiosInstance';

// Master Data Request API. The controller is [Authorize] and resolves the employee
// from the token, so no employee id is ever sent from here.

export const getMasterRequestResources = () =>
    adminInstance.get('resource/GetResource/MasterRequest');

// Owner
export const getMyMasterRequests = () =>
    adminInstance.get('masterrequest/GetList');

export const getMyMasterRequest = (id) =>
    adminInstance.get(`masterrequest/GetById/${id}`);

export const saveMasterRequest = (request) =>
    adminInstance.post('masterrequest/Save', { Request: request });

// Reviewer (IsAdmin + Coordinator)
export const getPendingMasterRequests = () =>
    adminInstance.get('masterrequest/GetPendingList');

export const getMasterRequestDetails = (id) =>
    adminInstance.get(`masterrequest/GetDetails/${id}`);

export const updateMasterRequestStatus = (payload) =>
    adminInstance.post('masterrequest/UpdateStatus', payload);

export const getMasterRequestReport = (fromDate, toDate) =>
    adminInstance.post('masterrequest/GetReport', { REP_FROM: fromDate, REP_TO: toDate });
